import { takeEvery, put, call } from "redux-saga/effects";
import {
  CREATE_ROLES,
  FETCH_ROLES,
} from "./actionTypes";
import {
  fetchRolesSuccess,
  fetchRolesFailure,
  createRolesSuccess,
  createRolesFailure,
  fetchRoles,
} from "./actions";
import { get, post, update, del } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Roless
function* fetchRolesSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);
    const response = yield call(post, process.env.REACT_APP_GET_ROLE_API, formData);
    yield put(fetchRolesSuccess(response));
  } catch (error) {
    console.error("Saga API Error:", error);
    yield put(fetchRolesFailure(error.message));
  }
}

function* createRolesSaga({ payload }) {
  try {
    const { formData, isEdit } = payload;
    const apiUrl = process.env.REACT_APP_SAVE_ROLE_API;
    const response = yield call(post, apiUrl, formData);
    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Role saved successfully!",
      });
      yield put(createRolesSuccess(response));
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createRolesFailure(response));
    }
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the role",
    });
    yield put(createRolesFailure(error.message));
  }
}

// Watcher Saga
function* roleSaga() {
  yield takeEvery(FETCH_ROLES, fetchRolesSaga);
  yield takeEvery(CREATE_ROLES, createRolesSaga);
}

export default roleSaga;
